import numberToFormattedString from './formatNumber';

export function objContainsValue(object, value) {
  for (let o in object) {
    if (object[o] === value) {
      return true;
    }
  }
  return false;
}

export function normalizeNumber(input, allowNegative) {
  if (!input || typeof input === 'number') {
    return input;
  }

  let result = input.replace(',', '.').replace(/[^0-9.]/g, '');

  if (allowNegative && input.startsWith('-')) {
    result = '-' + result;
  }

  return Number(result);
}

export function formatNumber(input) {
  // See test for use cases

  if (!input) {
    return input;
  }

  const isNegative = input.toString().startsWith('-');

  // Strip non-acceptable characters and ensure input is a string
  input = input.toString().replace(/[^0-9,.]/g, '');

  if (/[,.]/g.test(input)) {
    if (input.endsWith('.') || input.endsWith(',')) {
      return numberToFormattedString(input.replace(',', '.'), 0, 'plain') + ',';
    }

    // Does not end with , || .
    input = input.replace(',', '.');
    const splitInput = input.split(input.includes('.') ? '.' : ',');
    const decimals = splitInput[splitInput.length - 1];
    const decimalPlaces = decimals.length;
    if (isNegative) {
      input = '-' + input;
    }
    return numberToFormattedString(input, decimalPlaces, 'plain');
  }

  if (isNegative) {
    input = '-' + input;
  }
  // Does not contain , || .
  return numberToFormattedString(input, 0, 'plain');
}

export function isValidEmail(input) {
  /*eslint-disable*/
  const EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  /*eslint-enable*/
  return EMAIL_REGEXP.test(input);
}
